// Application configuration
// Uses environment variables with fallbacks for local development

export const config = {
  // API base URL for backend requests
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api',

  // Static assets URL (for images, etc.)
  staticUrl: import.meta.env.VITE_STATIC_URL || 'http://localhost:3000',

  // App metadata
  appName: import.meta.env.VITE_APP_NAME || 'LinkedIn Post Generator',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
};

// Helper function to get full static asset URL
export const getStaticUrl = (path) => {
  if (!path) return '';
  // If path already has protocol, return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${config.staticUrl}/${cleanPath}`;
};

export default config;
